@if (links.length) {
    <div class="list list-card row">
        @for (link of links; track link.url) {
            <ms-list-item
                msTrackReferringActionDirective
                class="col-12 col-sm-6"
                [trackingValue]="trackingValue()"
                [cleanAfterTrack]="cleanedAfterTrack()"
                [title]="link.title"
                [href]="link.url"
                [count]="link.count"
                [boldTitle]="isEpcot"
                [isShowBorder]="showBorder($last, $index)"
                (itemClicked)="onSelected(link)">
                @if ($index % 2 === 0 && !isMobile()) {
                    <span vertical-divider>
                        <ds-divider class="vertical-divider" vertical="true" />
                    </span>
                }
            </ms-list-item>
        }
    </div>
} @else {
    <ms-error severity="info" [message]="sitecore.event.ErrNoEvents" />
}
